import CustomButton from 'components/buttons/CustomButton'
import React from 'react'
import FontAwesome from 'react-fontawesome'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import I18n from '../../resources/i18n/I18n'

const EventSubmitButtons = ({ event, showError, disabled }) => {
  const history = useHistory()

  const goBack = () => {
    const currentPath = history.location.pathname
    history.push(
      history.location.state && history.location.state.from && history.location.state.from !== currentPath
        ? history.location.state.from
        : '/consulter',
    )
  }

  const goToNextStep = () => {
    history.replace(`/evenement/${event.id}/status`)
  }

  return (
    <div className="submit-form-footer">
      {showError && <p className="login-error text-center mt-3">{I18n.t('ReportSubmitError')}</p>}
      <div className="row justify-content-center p-4">
        <div className="p-1">
          <CustomButton onClick={goBack} icon={<FontAwesome name="arrow-left" />} small secondary />
        </div>
        {!disabled ? (
          <div className="p-1">
            <CustomButton title={I18n.t('CommonSave')} type="submit" small primary />
          </div>
        ) : (
          <div className="p-1">
            <CustomButton title={I18n.t('Next')} type="button" onClick={goToNextStep} small primary />
          </div>
        )}
      </div>
    </div>
  )
}

export default EventSubmitButtons
